import {
  getCustomFields,
  getCustomFieldsBasedOnType,
} from "@portal/api/custom-field";
import { DisputeFilterAtom } from "@portal/store/Filters/dipsutes/type";
import { InvoiceFilterAtom } from "@portal/store/Filters/Invoices/type";
import {
  CustomFieldTypes,
  CustomFieldDataResponse,
  CustomFieldEntityType,
} from "@portal/types/entities/custom-field";
import { useQuery } from "@tanstack/react-query";
import { SetStateAction } from "jotai";

const keyMap: Record<CustomFieldEntityType, string> = {
  CUSTOMER: "Customer",
  INVOICE: "Invoice",
  DISPUTE: "Dispute",
  CREDIT_MEMO: "",
  PAYMENT: "",
  CONTACT: "",
  ADDRESS: "",
};

export function useCustomFieldsQuery<T extends InvoiceFilterAtom | DisputeFilterAtom>(
  filterType: CustomFieldEntityType,
  setFilters: (value: SetStateAction<T>) => void
) {
  return useQuery({
    queryKey: ["custom-fields"],
    queryFn: () => getCustomFields(filterType),
    onSuccess(data) {
      const filteredFields = data
        .filter((f) => f.entity_type === filterType)
        .map((f) => ({
          key: f.id,
          label: f.display_name,
        }));

      setFilters((prev) => ({
        ...prev,
        filterGroup: prev.filterGroup.map((f) =>
          f.key === keyMap[filterType] ? { ...f, children: filteredFields } : f
        ),
      }));
    },
  });
}

export function useGetCustomFieldsBasedOnType(
  type: CustomFieldTypes,
  onSuccessCallBack?: (data: CustomFieldDataResponse[]) => void,
  enabled?: boolean,
  handleErrorCallBack?: () => void
) {
  return useQuery({
    queryKey: [`${type}`],
    queryFn: () => getCustomFieldsBasedOnType(type),
    retry: false,
    enabled,
    onSuccess(data) {
      onSuccessCallBack?.(data);
    },
    onError(err) {
      handleErrorCallBack?.();
    },
  });
}

